import React from "react";
import { Box } from "@mui/material";

const Callouts = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
        alignItems: "center",
        mb: { xs: 3, md: 4 },
        px: { xs: 2, sm: 0 },
      }}
    >
      <Box
        sx={{
          bgcolor: "#111",
          color: "white",
          // bgcolor: "#2E7D32",
          // color: "black",
          textAlign: "center",
          textTransform: "none",
          fontSize: "clamp(0.95rem, 2.2vw, 1.05rem)",
          lineHeight: 1.6,
          py: { xs: 1.1, sm: 1.25 },
          px: { xs: 1.75, sm: 2.5 },
          width: "100%",
          maxWidth: "40rem",
          borderRadius: "12px",
          cursor: "default",
        }}
      >
        Neurodegenerative disease &amp; protein misfolding diseases.
      </Box>
      <Box
        sx={{
          bgcolor: "#111",
          color: "white",
          // bgcolor: "#2E7D32",
          // color: "black",
          textAlign: "center",
          textTransform: "none",
          fontSize: "clamp(0.95rem, 2.2vw, 1.05rem)",
          lineHeight: 1.6,
          py: { xs: 1.1, sm: 1.25 },
          px: { xs: 1.75, sm: 2.5 },
          width: "100%",
          maxWidth: "40rem",
          borderRadius: "12px",
          cursor: "default",
        }}
      >
        Mediating science knowledge and understanding for funders, policy
        makers, pharmaceutical companies and the public.
      </Box>
    </Box>
  );
};

export default Callouts;
